module.exports = __webpack_public_path__ + "img/xmcc.51b536e6.svg";